<template>
  <router-link :to="to" class="news-card no-link">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-5">
        <img class="elevation-1" :src="img" :alt="title">
      </div>
      <div class="col-12 col-sm-6 col-md-7">
        <h1 class="lighter">NOTÍCIAS</h1>
        <h4 class="corbrown">{{ title }}</h4>
        <h5 v-html="textsubr"></h5>
        <h3 class="corbrown urldiv">VEJA +</h3>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: ['title', 'text', 'to', 'img'],
  computed: {
    day() {
      return new Date(this.date).toLocaleDateString('pt-BR', { day: '2-digit' })
    },
    month() {
      return new Date(this.date).toLocaleDateString('pt-BR', { month: 'short' }).toUpperCase().slice(0, -1)
    },
    year() {
      return new Date(this.date).getFullYear()
    },
    textsubr(){
      return this.text.substr(0,1200)
    }
  },
}
</script>

<style>
.news-card div {
  width: 100%;
  background: #fff;
  position: relative;
}
.corbrown{
  color: #4f372a;
  font-weight: bold;
  margin:20px 0
}
.news-card img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.news-card h5 {
  white-space: normal;
}
.news-card time {
  position: absolute;
  top: 8px;
  left: -4px;
  width: 60px;
  border-radius: 2px;
  display: grid;
  grid-template-rows: 60px 20px;
  padding-left: 2px;
}
.news-card .news-card-month {
  line-height: 14px !important;
}
.news-card .news-card-day {
  line-height: 18px !important;
}
.urldiv{
  text-align: right;
  font-weight: bold;
}
.lighter{
  font-weight: lighter;
}
</style>